export function normalizeString(s) {
    return s.normalize('NFD').replace(/\p{Diacritic}/gu, "").toLowerCase().trim();
}

export function normalizeCompareStrings(s1, s2) {
    return normalizeString(s1).localeCompare(normalizeString(s2))
}